import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";



export const getQuestions = async () => {
  const candidates = [
    `${BASE_URL}/questions`,
    "http://127.0.0.1:8000/api/questions",
    "http://127.0.0.1:8000/questions",
    "http://api/questions",
  ];

  let lastError = null;

  for (const url of candidates) {
    try {
      const res = await axios.get(url);
      if (res.data && typeof res.data === "object" && !Array.isArray(res.data)) {
        return { ...res.data, _httpStatus: res.status, _sourceUrl: url };
      }

      return { pillar: [], _httpStatus: res.status, _sourceUrl: url };
    } catch (err) {
      lastError = err;
    }
  }

  console.error("Error fetching questions from all configured endpoints:", lastError);
  throw lastError;
};

export const submitAssessment = async (company, responses) => {
  try {
    const formattedResponses = {};
    Object.entries(responses).forEach(([qid, ans]) => {
      if (typeof ans === "object" && ans !== null && "score" in ans) {
        formattedResponses[qid] = Number(ans.score);
        return;
      }

      formattedResponses[qid] = Number(ans);
    });

    const rawPhone = company.phone || "";
    const countryCode = company.countryCode || "";

    let phoneNumber = rawPhone.replace(/\D/g, ""); // only digits
    if (countryCode && phoneNumber.startsWith(countryCode.replace(/\D/g, ""))) {
      phoneNumber = phoneNumber.slice(countryCode.replace(/\D/g, "").length);
    }

    const payload = {
      company_name: company.company_name || company.companyName,
      email: company.email,
      industry: company.industry,
      designation: company.designation || company.jobTitle,
      employee_size: company.size || company.employeeSize,
      website: company.website || "",
      phone: countryCode ? `${countryCode}${phoneNumber}` : rawPhone,
      responses: formattedResponses,
    };

    console.log("Submitting Assessment Payload:", payload);

   const res = await axios.post(`${BASE_URL}/assessment/submit`, payload);
return {
  ...res.data,
  assessment_id: res.data.id  // added for UserDetailsPage
};
 
  } catch (err) {
    console.error("Error submitting assessment:", err);
    return null;
  }
};

export const sendUserDetails = async (userData) => {
  try {
    const res = await axios.post(`${BASE_URL}/user-details`, userData);
    return res.data;
  } catch (err) {
    console.error("Error sending user details:", err);
    return null;
  }
};

export const verifyOtp = async (data) => {
  try {
    const res = await axios.post(`${BASE_URL}/verify-otp`, data);
    return res.data;
  } catch (err) {
    console.error("Error verifying OTP:", err);
    throw err;
  }
};
